import { LngLatBounds } from '@yandex/ymaps3-types';

export const getBounds = (coordinates: number[][]): LngLatBounds | null => {
  if (!coordinates?.length) return null;

  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;

  coordinates?.forEach(point => {
    const [x, y] = point;
    minX = Math.min(minX, x);
    minY = Math.min(minY, y);
    maxX = Math.max(maxX, x);
    maxY = Math.max(maxY, y);
  });

  return [
    [minX, minY],
    [maxX, maxY]
  ];
};
